import { C_GET_ADVERTISER_REQUEST, C_GET_ADVERTISER_SUCCESS, C_GET_ADVERTISER_FAILED, C_GET_S3FILESANDFOLDERS_FAILED, C_GET_S3FILESANDFOLDERS_REQUEST, C_GET_S3FILESANDFOLDERS_SUCCESS, C_VALIDATE_FOLDER_NAME_REQUEST, C_VALIDATE_FOLDER_NAME_SUCCESS, C_VALIDATE_FOLDER_NAME_FAILED, C_UPLOAD_FILES_REQUEST, C_UPLOAD_FILES_SUCCESS, C_UPLOAD_FILES_FAILED, C_UPLOAD_TO_DSP_REQUEST, C_UPLOAD_TO_DSP_SUCCESS, C_UPLOAD_TO_DSP_FAILED, C_GET_LINEITEMS_REQUEST, C_GET_LINEITEMS_FAILED, C_GET_LINEITEMS_SUCCESS } from "../Actions/CreativeUploadActions";

const InitialState = {
    loading: false,
    success: false,
    adv: [],
    s3Files: [],
    s3Folders: [],
    validName: false,
    lineItems:[]
}

export const CreativeUploadReducer = (state = InitialState, action: any) => {
    switch (action.type) {
        case C_GET_ADVERTISER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case C_GET_ADVERTISER_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                adv: action.payload
            };
        case C_GET_ADVERTISER_FAILED:
            return {
                ...state,
                loading: false,
                success: false
            };
        case C_GET_S3FILESANDFOLDERS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case C_GET_S3FILESANDFOLDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                s3Files: action.payload.files,
                s3Folders: action.payload.folders,
                curFolder: action.payload.curFolder
            };
        case C_GET_S3FILESANDFOLDERS_FAILED:
            return {
                ...state,
                loading: false,
                success: false
            };
        case C_VALIDATE_FOLDER_NAME_REQUEST:
            return {
                ...state,
                loading: true
            };
        case C_VALIDATE_FOLDER_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                validName: action.payload,
            };
        case C_VALIDATE_FOLDER_NAME_FAILED:
            return {
                ...state,
                loading: false
            };
        case C_UPLOAD_FILES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case C_UPLOAD_FILES_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case C_UPLOAD_FILES_FAILED:
            return {
                ...state,
                loading: false,
                success: false
            };
        case C_UPLOAD_TO_DSP_REQUEST:
            return {
                ...state,
                loading: true
            };
        case C_UPLOAD_TO_DSP_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case C_UPLOAD_TO_DSP_FAILED:
            return {
                ...state,
                loading: false,
                success: false
            };
        case C_GET_LINEITEMS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case C_GET_LINEITEMS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                lineItems: action.payload
            };
        case C_GET_LINEITEMS_FAILED:
            return {
                ...state,
                loading: false,
                success: false
            };


        default:
            return state;
    }
}